import React from 'react';
import { FormattedMessage } from '@kyruus/intl';

import Search from '@kyruus/react-ikons/Search';

import { messages } from '../../lib/messages';
import { messages as searchAreaMessages } from '../../../search-v9/components/SearchAreaButton/messages';
import {
  OPEN_MAPS_FILTER_DRAWER,
  CLICK_BACK_TO_LIST_VIEW_BUTTON
} from '../../lib/constants';

import {
  NavigationContainer,
  StyledListButton,
  StyledFiltersButton,
  StyledSearchButton
} from './styles';

function NavigationButtons({
  backToSearchUrl,
  onSearchAreaClick,
  onFiltersClick,
  history,
  log,
  isFiltersDisabled = false,
  showSearchThisArea = false
}) {
  const handleBackToListClick = (e) => {
    e.preventDefault();
    log(CLICK_BACK_TO_LIST_VIEW_BUTTON);
    history.push(backToSearchUrl);
  };

  const handleFiltersClick = () => {
    log(OPEN_MAPS_FILTER_DRAWER);
    onFiltersClick();
  };

  const handleSearchAreaClick = () => {
    if (onSearchAreaClick) {
      onSearchAreaClick();
    }
  };

  return (
    <NavigationContainer data-testid="MapNavigationButtons">
      {backToSearchUrl && (
        <StyledListButton
          href={backToSearchUrl}
          data-testid="NavigationListButton"
          onClick={handleBackToListClick}
        >
          <FormattedMessage {...messages.backToList} />
        </StyledListButton>
      )}

      {showSearchThisArea && (
        <StyledSearchButton
          mode="ghost"
          active={true}
          icon={<Search size="1em" />}
          iconAlign="left"
          data-testid="NavigationSearchButton"
          onClick={handleSearchAreaClick}
        >
          <FormattedMessage {...searchAreaMessages.searchArea} />
        </StyledSearchButton>
      )}

      <StyledFiltersButton
        data-testid="NavigationFiltersButton"
        disabled={isFiltersDisabled}
        onClick={handleFiltersClick}
      >
        <FormattedMessage {...messages.filtersBtn} />
      </StyledFiltersButton>
    </NavigationContainer>
  );
}

export default NavigationButtons;
